import { useEffect, useState } from "react";
import "../../../Styles/style.css";
import AdminApiModule from "../../../components/AdminApi/Api/api";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import ViewRole from "./ViewRole";
import { connect, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  canViewRoles,
  canAddRole,
  canUpdateRole,
} from "../../../utility/permissionUtils";

const Roles = (props) => {
  const navigate = useNavigate();
  const [rolesList, setRolesList] = useState([]);
  const [isViewRoleOpen, setIsViewRoleOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState({});

  // Get user permissions from Redux store
  const globalState = useSelector((state) => state.AdminReducer);
  const userPermissions = globalState?.adminDetails?.role_id?.permissions;

  // Check permissions
  const hasViewAccess = canViewRoles(userPermissions);
  const hasAddAccess = canAddRole(userPermissions);
  const hasUpdateAccess = canUpdateRole(userPermissions);

  // Create an instance of AdminApiModule
  const adminApi = new AdminApiModule();

  const parseRoleObject = (roleObject) => {
    let resultObject = {
      addCenter: roleObject?.permissions?.add_center,
      updateCenterFullAccess:
        roleObject?.permissions?.update_center?.full_access,
      deleteCenter: roleObject?.permissions?.delete_center,
      viewCenterDetailsFullAccess:
        roleObject?.permissions?.view_center_details?.full_access,
      viewCenterDetailsViewPincode:
        roleObject?.permissions?.view_center_details?.view_pincode,
      addTechnician: roleObject?.permissions?.add_technician,
      updateTechnicianFullAccess:
        roleObject?.permissions?.update_technician?.full_access,
      deleteTechnician: roleObject?.permissions?.delete_technician,
      viewTechnicianDetailsFullAccess:
        roleObject?.permissions?.view_technician_details?.full_access,
      viewTechnicianDetailsTechnicianPhone:
        roleObject?.permissions?.view_technician_details?.technician_phone,
      viewDashboardFullAccess:
        roleObject?.permissions?.view_dashboard_full_access,
      addNewServices: roleObject?.permissions?.add_new_services,
      updateServicesFullAccess:
        roleObject?.permissions?.update_services?.full_access,
      inActiveActive: roleObject?.permissions?.inactive_active,
      viewServicesListFullAccess:
        roleObject?.permissions?.view_services_list?.full_access,
      addTicket: roleObject?.permissions?.add_ticket,
      editTicketFullAccess: roleObject?.permissions?.edit_ticket?.full_access,
      deleteTicket: roleObject?.permissions?.delete_ticket,
      viewTicketFullAccess: roleObject?.permissions?.view_ticket?.full_access,
      addClients: roleObject?.permissions?.add_clients,
      editClientsFullAccess: roleObject?.permissions?.edit_clients?.full_access,
      viewClientsFullAccess: roleObject?.permissions?.view_clients?.full_access,
      viewBroadcastedListFullAccess:
        roleObject?.permissions?.view_broadcastedList,
      addRole: roleObject?.permissions?.add_role,
      editRoleFullAccess:
        roleObject?.permissions?.edit_role_permissions?.full_access,
      deleteRole: roleObject?.permissions?.delete_role,
      viewRoleFullAccess: roleObject?.permissions?.view_role?.full_access,
      viewWalletTransaction: roleObject?.permissions?.view_Wallet,
      viewPendingTickets: roleObject?.permissions?.view_pending_ticket,
      viewClosedTickets: roleObject?.permissions?.view_closed_ticket,
      viewsidebar: roleObject?.permissions?.view_admin_bar,
      viewCenterTickets: roleObject?.permissions?.view_center_ticket,
      viewbanner: roleObject?.permissions?.view_banner,
      viewoffers: roleObject?.permissions?.view_offers,
      viewsubscription: roleObject?.permissions?.view_subscription,
    };
    return resultObject;
  };

  const handleViewRole = (roleObject) => {
    let roleObjectValue = parseRoleObject(roleObject);
    setSelectedRole(roleObjectValue);
    setIsViewRoleOpen(true);
  };

  const handleCloseViewRole = () => {
    setIsViewRoleOpen(false);
  };

  const getAllAvailableRoles = () => {
    adminApi
      .getAllAvailableRoles()
      .then((res) => {
        let parsedData = [];
        if (res && res.data && res.data.length > 0) {
          parsedData = res.data;
        }
        setRolesList(parsedData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleAddRole = () => {
    navigate("/add-role");
  };

  const handleEditRole = (id) => {
    navigate("/add-role?edit=" + id);
  };

  useEffect(() => {
    if (hasViewAccess) {
      getAllAvailableRoles();
    }
  }, [hasViewAccess]);

  // If user doesn't have view access, show access denied message
  if (!hasViewAccess) {
    return (
      <div className="access-denied-container">
        <div className="access-denied-message">
          <h3>Access Denied</h3>
          <p>
            You don't have permission to view roles. Please contact your
            administrator.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="add-service-button">
        {hasAddAccess && (
          <Button
            variant="contained"
            className="text-transform-none"
            onClick={handleAddRole}
          >
            Add a Role
          </Button>
        )}
      </div>

      <div>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Role Name</TableCell>
                {hasUpdateAccess && <TableCell>Action</TableCell>}
                <TableCell>View</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rolesList &&
                rolesList.length > 0 &&
                rolesList.map((row) => (
                  <TableRow
                    key={row._id}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell component="th" scope="row">
                      {row.role_name}
                    </TableCell>
                    {hasUpdateAccess && (
                      <TableCell component="th" scope="row">
                        <Button
                          variant="outlined"
                          onClick={() => handleEditRole(row._id)}
                        >
                          Edit Role
                        </Button>
                      </TableCell>
                    )}
                    <TableCell component="th" scope="row">
                      <Button
                        variant="outlined"
                        onClick={() => handleViewRole(row)}
                      >
                        View Role
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <div>
        <ViewRole
          isViewRoleOpen={isViewRoleOpen}
          handleCloseViewRole={handleCloseViewRole}
          roleObject={selectedRole}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  reduxState: state.userReducer,
});

export default connect(mapStateToProps, null)(Roles);
